import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { authHeaders, axiosInstance, encodeValue } from '../../utils/helper';
import { uniqueID } from '../../utils/constants';

const initialState = {
	data: [],
	loading: false,

	detail: null,
	loadingDetail: false,

	categories: [],
	isLoadingCategory: false,
	selectedCategory: 'all',

	keyword: null,
	isLoadingSearch: false,
};

export const handleGetProductsOutlet = createAsyncThunk('outlet/handleGetProductsOutlet', async ({ storeID, companyID }) => {
	let url = `catalogs/listproducts?unquieid=${uniqueID}&storeID=${storeID}`;
	if (companyID) {
		url += `&company_id=${companyID}`;
	}

	const res = await axiosInstance.get(url);
	const data = await res.data;
	return data;
});

export const handleGetProductsOutletV2 = createAsyncThunk('outlet/handleGetProductsOutletV2', async ({ storeID, companyID }) => {
	let url = `products/list?unquieid=${uniqueID}&storeID=${storeID}`;
	if (companyID) {
		url += `&company_id=${companyID}`;
	}

	const res = await axiosInstance.get(url, authHeaders());
	const data = await res.data;
	return data;
});

export const handleGetProductDetail = createAsyncThunk('outlet/handleGetProductDetail', async ({ storeID, companyID, productID }) => {
	let url = `catalogs/productdetails?unquieid=${uniqueID}&storeID=${encodeValue(storeID)}&productID=${productID}`;
	if (companyID) {
		url += `&companyID=${encodeValue(companyID)}`;
	}

	const res = await axiosInstance.get(url, authHeaders());
	const data = await res.data;
	return data;
});

export const getCategory = createAsyncThunk('outlet/getCategory', async ({ storeID, availability }) => {
	let url = `catalogs/listcategory?unquieid=${uniqueID}&storeID=${encodeValue(storeID)}&availability=${availability}`;

	const res = await axiosInstance.get(url);
	const data = await res.data;
	const allCategory = {
		categoryName: 'All',
		categoryImage: '',
		catSlug: 'all',
	};
	const result = [allCategory, ...(data?.result ?? [])];
	return result;
});

const product = createSlice({
	name: 'product',
	initialState,
	reducers: {
		setProducts: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearProducts: (state) => {
			state.data = [];
		},
		setDetail: (state, action) => {
			state.detail = action.payload;
		},
		clearDetail: (state) => {
			state.detail = null;
		},
		setCategory: (state, action) => {
			return { ...state, ...action.payload };
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(handleGetProductsOutlet.pending, (state) => {
				state.loading = true;
			})
			.addCase(handleGetProductsOutlet.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload.result || [];
			})
			.addCase(handleGetProductsOutlet.rejected, (state) => {
				state.loading = false;
			})
			.addCase(handleGetProductDetail.pending, (state) => {
				state.loadingDetail = true;
			})
			.addCase(handleGetProductDetail.fulfilled, (state, action) => {
				state.loadingDetail = false;
				state.detail = action.payload.result || null;
			})
			.addCase(handleGetProductDetail.rejected, (state) => {
				state.loadingDetail = false;
			})
			.addCase(getCategory.pending, (state) => {
				state.isLoadingCategory = true;
			})
			.addCase(getCategory.fulfilled, (state, action) => {
				state.isLoadingCategory = false;
				state.categories = action.payload || [];
			})
			.addCase(getCategory.rejected, (state) => {
				state.isLoadingCategory = false;
			})
			.addCase(handleGetProductsOutletV2.pending, (state) => {
				state.loading = true;
			})
			.addCase(handleGetProductsOutletV2.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload.result || [];
			})
			.addCase(handleGetProductsOutletV2.rejected, (state) => {
				state.loading = false;
			});
	},
});

// Export actions and reducer
export const { setProducts, clearProducts, setDetail, clearDetail, setCategory } = product.actions;
export default product.reducer;
